module.exports = __webpack_public_path__ + "static/media/power-of-integration-tests.adcad703.md";